export default __webpack_public_path__ + "static/media/isometric-tiles.93de852a.png";